module.exports = __webpack_public_path__ + "static/media/nist_logo.7f23e237.png";